import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "reorder-down-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.4697 21.4498C11.7626 21.7427 12.2374 21.7427 12.5303 21.4498L18.5699 15.4102C18.8628 15.1173 18.8628 14.6425 18.5699 14.3496C18.277 14.0567 17.8021 14.0567 17.5092 14.3496L12.75 19.1088V6.49862C12.75 6.0844 12.4142 5.74862 12 5.74862C11.5858 5.74862 11.25 6.0844 11.25 6.49862V19.1088L6.49078 14.3496C6.19789 14.0567 5.72301 14.0567 5.43012 14.3496C5.13723 14.6425 5.13723 15.1173 5.43012 15.4102L11.4697 21.4498ZM5.96045 3.83032C5.54624 3.83032 5.21045 3.49454 5.21045 3.08032C5.21045 2.66611 5.54624 2.33032 5.96045 2.33032H18.0345C18.4487 2.33032 18.7845 2.66611 18.7845 3.08032C18.7845 3.49454 18.4487 3.83032 18.0345 3.83032H5.96045Z"
    }, null, -1)
  ])))
}
export default { render: render }